import { render, staticRenderFns } from "./Kumppani.vue?vue&type=template&id=090487c6&"
import script from "./Kumppani.vue?vue&type=script&lang=js&"
export * from "./Kumppani.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports